<template>
  <Navbar />
  <LoadingScreen id="loading-screen" />
  <div class="content">
    <router-link class="add-business-link" to="/add_business">
      <Button
        class="add-business-btn"
        text="Add a Pet-Friendly Business"
        icon="dog"
        color="var(--success)"
      />
    </router-link>
    <div class="filter">
      <label for="filter">Show</label>
      <div class="select">
        <select
          name="filter"
          id="business-filter-selector"
          v-model="businessFilter"
          @change="updateBusinessFilterMethod"
        >
          <option selected="selected" value="all">All</option>
          <option value="Doctors">Doctors</option>
          <option value="Pet_supplies">Pet supplies</option>
          <option value="Groomers">Groomers</option>
          <option value="Trainers">Trainers</option>
          <option value="Nannies">Nannies</option>
          <option value="Hotels">Hotels</option>
          <option value="Walkers">Walkers</option>
          <option value="Shelters">Shelters</option>
          <option value="Other_Services">Other Services</option>
        </select>
      </div>
    </div>
    <div class="businesses-container">
      <div class="business">
        <h3 :style="businesses === {} ? 'display:block' : 'display:none'">
          There are not pet-friendly businesses yet.
        </h3>
        <router-link
          v-for="business in filteredBusiness"
          :key="business._id"
          :to="'/business_info?id=' + business._id"
          class="business-link"
        >
          <div class="business-logo">
            <img
              :src="backend + '/business/images/' + business.logo"
              onerror="this.src='/paw.svg'"
              :alt="business.name + '\'s logo'"
            />
          </div>
          <div class="business-info">
            <p class="business-name">{{ business.name }}</p>
            <p class="business-type">
              {{ business.type.replaceAll("_", " ") }}
            </p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingScreen from "@/components/LoadingScreen.vue";
import Navbar from "@/components/Navbar.vue";
import axios from "axios";
import Button from "@/components/Button.vue";

function updateBusinessFilter(_self) {
  // console.log("UPDATING BUSINESS FILTER");
  if (_self.businessFilter.toLowerCase() === "all") {
    _self.filteredBusiness = _self.business;
  } else {
    _self.filteredBusiness = _self.business.filter(function (obj) {
      return obj.type == _self.businessFilter;
    });
  }
}

export default {
  components: {
    LoadingScreen,
    Navbar,
    Button,
  },
  name: "Businesses",
  mounted() {
    let self = this;
    let jwt = localStorage.getItem("jwt");

    let title = "Businesses - Dating4Pets";
    document.title = title;

    this.backend = process.env.VUE_APP_BACKEND;

    if (jwt == null) {
      self.$router.push("/");
    } else {
      let headers = {
        Authorization: "Bearer " + jwt,
      };

      axios
        .get(`${process.env.VUE_APP_BACKEND}/business/all`, {
          headers: headers,
        })
        .then((res) => {
          self.business = res.data;

          setTimeout(() => {
            let loadingScreen = document.querySelector("#loading-screen");
            loadingScreen.classList.add("fade-out");
            updateBusinessFilter(this);
          }, 1000);
        })
        .catch((err) => {
          console.log("ERROR: " + err);
          self.$router.push("/");
        });
    }
  },
  data() {
    return {
      business: {},
      backend: "",
      businessFilter: "all",
      filteredBusiness: [],
    };
  },
  methods: {
    updateBusinessFilterMethod() {
      updateBusinessFilter(this);
    },
  },
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: visible;
  padding: 2em;
  padding-block-start: 8em;
}

.businesses-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* top: 6em;
  position: absolute; */
  overflow: visible;
}

.business {
  width: 100%;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block: 1em;
}
.business-link {
  background: var(--light-clr);
  padding: 2rem;
  border-radius: var(--border-radius);
  box-shadow: var(--light-box-shadow);
  min-width: 15em;
  width: 100%;
  max-width: 35em;
  display: flex;
  align-items: center;
  gap: 2em;
  cursor: pointer;
  transition: var(--transition);
  margin-block: 1em;
}

.business-link:hover,
.business-link:focus {
  background: var(--faint-bg);
}

.business-link:hover p,
.business-link:focus p {
  color: var(--light-clr);
}

.business-logo {
  height: 3em;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: var(--light-box-shadow);
  background: var(--light-clr);
}

.business-logo img {
  width: 100%;
}

.business-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.business-name {
  font-weight: bolder;
  font-size: 1.2em;
}

.business-type {
  font-weight: lighter;
}

.add-business-link {
  overflow: visible;
}

.filter {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--gap);
  font-size: 1.2em;
  overflow: visible;
  margin-block: 1em;
}

.filter label {
  overflow: visible;
}

@media screen and (max-width: 40rem) {
  .filter {
    flex-direction: column;
  }
}

.select {
  overflow: visible;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

select {
  border: none;
  width: 10em;
  padding: 1em;
  background: white;
  border-radius: 4em;
  color: #454545;
  cursor: pointer;
  font-size: inherit;
  box-shadow: var(--light-box-shadow);
  appearance: none;
  transition: var(--transition);
  z-index: 2;
}

.select::after {
  content: "";
  width: 2em;
  aspect-ratio: 1;
  top: 60%;
  left: calc(50% - 1em);
  background: white;
  transform: rotate(45deg);
  position: absolute;
  border-radius: var(--border-radius);
  box-shadow: var(--light-box-shadow);
  z-index: 1;
  transition: var(--transition);
  opacity: 0;
}

.select:hover select,
.select:focus select,
.select:hover::after,
.select:focus::after {
  box-shadow: var(--box-shadow-focus);
  opacity: 1;
}
</style>
